var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/login"}},[_c('div',{staticClass:"btn btn-outline disabled"},[_c('span',{staticClass:" select-none"},[_vm._v("Login")])])])}
var staticRenderFns = []

export { render, staticRenderFns }